import { render } from "./Tiktok.vue?vue&type=template&id=b2d6c1a6"
const script = {}
script.render = render

export default script